/**
 * Les bandeaux du live, en file : ceux de la page (l'activité poussée, le micro coupé, Sam envoyé) et
 * ceux de l'écran (`notices`) se posent au même endroit, au-dessus des pieds. Visibles ensemble, ils
 * se couvraient. Un seul se montre, **le dernier arrivé** (Wajih, 20/10 : « dernier devant ») : il
 * prend la place tout de suite, avec sa propre durée, et celui qu'il remplace est dépassé, il ne revient
 * pas (la page le referme).
 */

export type LiveNoticeQueue = {
    /** Le bandeau montré, ou `null`. */
    front: string | null
    /** Ceux qui ont encore quelque chose à dire mais ont été dépassés : ils ne se montrent plus. */
    superseded: readonly string[]
}

export const initialLiveNoticeQueue: LiveNoticeQueue = { front: null, superseded: [] }

/**
 * La file d'après, lue sur les bandeaux qui ont quelque chose à dire (`active`, dans l'ordre de la
 * page). Un bandeau qui arrive passe devant ; arrivés ensemble, le premier de `active`. Inchangée, c'est
 * la même file (la page la garde en état sans se relancer).
 */
export function liveNoticeQueue(previous: LiveNoticeQueue, active: readonly string[]): LiveNoticeQueue {
    const arrived = active.filter((key) => key !== previous.front && !previous.superseded.includes(key))
    if (arrived.length > 0) {
        const front = arrived[0]
        return { front, superseded: active.filter((key) => key !== front) }
    }
    const front = previous.front != null && active.includes(previous.front) ? previous.front : null
    const superseded = previous.superseded.filter((key) => active.includes(key))
    if (front === previous.front && superseded.length === previous.superseded.length) return previous
    return { front, superseded }
}
